var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBgHome5C({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 613,
    height: 563,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    fill: "#54E596",
    d: "M289.089 244.237c4.043-3.795 8.427-7.818 15.169-10.119 18.419-6.288 46.464-6.777 45.107 21.474.272 9.566-15.692 14.967-21.525 19.37-6.712 5.068-14.2 10.77-8.706 19.322 2.827 4.401 7.575 8.357 9.004 13.492 2.058 7.398 2.213 12.98.777 20.727-2.775 14.976-25.542 19.383-37.072 11.918-20.182-13.067-23.944-38.913-20.084-60.66 2.36-13.295 7.353-26.16 17.33-35.524Z",
    style: {
      stroke: "none",
      strokeOpacity: 1,
      fill: "#518d64",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#FFBABA",
    strokeWidth: 5,
    d: "M185.522 360.398c-5.475-16.934-6.411-33.436-3.619-46.376 2.807-13.014 9.23-21.914 18.035-24.761 8.806-2.847 19.223.61 29.117 9.517 9.839 8.857 18.74 22.784 24.214 39.719 5.475 16.934 6.411 33.435 3.619 46.376-2.807 13.013-9.23 21.914-18.035 24.761-8.806 2.846-19.223-.61-29.117-9.517-9.839-8.858-18.74-22.785-24.214-39.719Z",
    style: {
      stroke: "#e6abab",
      strokeOpacity: 1
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#0E0E2C",
    strokeLinecap: "square",
    strokeWidth: 5,
    d: "M110.219 203.095c-27.722 81.883 63.131 57.209 45.151 38.81-13.042-13.345-21.193 12.575-1.871 23.29 14.122 7.831 23.789 4.019 37.087-3.191 13.292-7.206 23.915-9.007 38.913-4.075 11.945 3.928 19.512 8.818 28.936 16.524"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply",
      fill: "#bfa1d6",
      fillOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#D096FE",
    d: "m300.717 451.318-66.681 3.984-15.959-92.566 109.305 7.141-26.665 81.441Z",
    style: {
      fill: "#bfa1d6",
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#ACF6E4",
    d: "M359.307 32.097c-3.396 3.323-5.652 7.754-8.03 11.823-2.379 4.069-4.115 8.486-5.367 13.143-1.241 4.572-2.674 9.29-2.73 14.028-.055 4.737.108 9.764 1.284 14.327 1.005 3.936 2.941 8.002 3.584 12.06.692 4.324.355 7.987-2.134 11.609-3.222 4.555-8.045 7.594-13.235 9.546-4.561 1.78-8.759 4.043-12.627 7.042-3.88 3.083-8.221 5.757-10.708 9.984-2.486 4.226-4.378 9.139-4.807 14.083-.43 4.944 1.315 9.76 3.446 14.284 2.399 5.079 5.487 10.168 9.922 13.632 4.29 3.272 9.591 5.476 14.758 7.404 5.167 1.927 10.689 1.919 16.031 1.973 5.426.065 10.876-.039 15.931-2.269 4.959-2.156 8.473-6.326 11.818-10.519 3.356-4.278 6.905-8.702 7.89-13.914.996-5.296.227-10.925-2.088-15.992-2.046-4.512-6.241-8.461-8.734-12.863-2.773-4.872-3.578-10.247-1.251-15.186 1.739-3.813 5.318-6.593 8.899-8.769 3.678-2.249 7.356-4.497 11.106-6.65 3.678-2.249 7.563-4.124 11.241-6.372 4.618-2.808 9.356-5.859 13.61-9.149 4.351-3.362 8.325-7.123 11.306-11.798 2.535-3.96 3.087-8.543 3.82-13.186.721-4.559 1.441-9.117.434-13.657-.91-4.613-3.305-8.484-5.772-12.45-2.468-3.968-4.116-8.856-7.884-11.538-4.386-3.198-10.092-3.734-15.328-4.55-5.162-.718-10.603-1.303-15.855-.136-5.241 1.082-10.614 2.491-15.354 4.937-4.802 2.265-9.564 5.484-13.176 9.123Z",
    style: {
      fill: "#97dbcb",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply",
      fill: "#77c69b",
      fillOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ADF084",
    d: "M15.12 155.637c3.035 15.323 16.417 29.479 24.474 42.327 6.768 10.793-20.02-13.9-32.857-15.456-41.05-4.975 123.42 137.515 105.945 14.46-4.142-29.164-15.58-54.169-45.864-62.158-24.491-6.462 12.389 65.172-6.768 34.529-5.925-9.476-51.823-48.511-44.93-13.702Z",
    style: {
      fill: "#77c69b",
      fillOpacity: 1
    }
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#0E0E2C",
    strokeLinecap: "square",
    strokeWidth: 5,
    d: "M421.33 55.184c-35.128 29.7-79.151 89.856-63.773 139.155 8.895 28.495 45.53 42.667 64.527 15.378 19.599-28.193 15.981-66.637 37.238-94.227 4.373-5.729 18.092-17.489 25.48-9.046 10.402 11.91-14.474 29.55-14.022 42.063.302 12.212 16.735 12.966 24.575 7.84 7.84-5.126 12.363-13.72 17.79-21.258 21.107-29.399 61.21-43.57 96.037-33.922"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#ffbaba",
    d: "M220.793 50.076 215.7 136.42l42.587-11.735 34.303-4.043-9.88-81.427z",
    style: {
      mixBlendMode: "multiply",
      stroke: "none",
      strokeOpacity: 1,
      fill: "#e6abab",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply",
      stroke: "#e6abab",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "#09AC53",
    strokeWidth: 5,
    d: "M144.204 78.695c-5.863-6.607-4.801-17.761 3.217-24.892 8.018-7.13 19.208-6.871 25.071-.264 5.862 6.606 4.801 17.76-3.218 24.89-8.018 7.132-19.207 6.872-25.07.266z",
    style: {
      stroke: "#e6abab",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#0E0E2C",
    d: "m187.345 133.253-10.418-4.98-11.309 2.433-6.006 7.201-4.703 8.256-.554 11.591-.061 11.58 4.586 10.671 6.189 9.701 7.162 9.187 10.624 4.946 11.073 2.968 11.338 1.159 11.285-1.3 11.263-2.709 11.653-11.45 3.06-11.793 1.057-11.11.69-11.19-.758-15.255-4.282-14.813-11.315-10.406-14.759-1.793-6.632 5.117-1.552 5.125 3.636 10.898 1.62 11.514-6.488 8.974-8.749-3.845-3.213-10.475-4.437-10.202Z",
    style: {
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply",
      fill: "#fae89a",
      fillOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#F7B568",
    d: "M439.772 269.007c-.475 1.468-1.376 10.202-23.499 42.885-13.606 20.1-45.314 31.369-70.695 32.555-15.888.743-26.75-5.087-37.025-7.058 6.606-15.462 15.665-28.958 27.199-41.926 16.612-18.677 37.916-30.621 44.279-32.726 10.779-3.565 60.215 4.802 59.741 6.27Z",
    style: {
      fill: "#fae89a",
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#0E0E2C",
    strokeLinecap: "square",
    strokeWidth: 5,
    d: "M357.418 312.171c17.425 2.79 34.784-1.794 50.236-9.901 14.532-7.641 28.406-20.066 46.028-17.608 11.704 1.662 22.619 8.838 34.455 10.897 13.414 2.392 27.879-2.192 38.137-11.162",
    style: {
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply",
      stroke: "none",
      strokeOpacity: 1,
      fill: "#518d64",
      fillOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#54E596",
    d: "M159.773 329.342c-1.016.095-6.079 1.757-34.625-2.706-17.556-2.744-39.728-17.996-53.349-32.155-8.527-8.863-11.017-16.501-15.24-22.843 11.529-.087 23.278 1.712 36.015 5.052 18.346 4.81 35.546 13.969 39.913 17.069 7.398 5.251 28.302 35.488 27.286 35.583Z",
    style: {
      stroke: "none",
      strokeOpacity: 1,
      fill: "#518d64",
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply",
      stroke: "none",
      strokeOpacity: 1,
      fill: "#518d64",
      fillOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#54E596",
    d: "M159.187 318.787c-.581.839-2.566 5.783-24.35 24.764-13.397 11.673-39.339 18.833-58.941 20.149-12.272.825-19.72-2.183-27.292-3.032 7.35-8.881 16.287-16.717 27.04-24.319 15.486-10.948 33.565-18.222 38.747-19.57 8.78-2.284 45.377 1.168 44.796 2.008Z",
    style: {
      stroke: "none",
      strokeOpacity: 1,
      fill: "#518d64",
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply",
      stroke: "none",
      strokeOpacity: 1,
      fill: "#518d64",
      fillOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#54E596",
    d: "M122.399 106.983s-9.362 6.093-34.329-12.632C72.715 82.835 67.386 57.225 66.75 36.997 66.35 24.333 71.091.252 71.091.252L122.4 106.983Z",
    style: {
      stroke: "none",
      strokeOpacity: 1,
      fill: "#518d64",
      fillOpacity: 1
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBgHome5C);
export default __webpack_public_path__ + "static/media/bg_home5_c.491bd78071cfd2a8e25db31e1895a91b.svg";
export { ForwardRef as ReactComponent };